import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
export interface IAttachDocuments {
  diasPendentes: number
  tipoPendenciaId: string
  nmFornecedor: string
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  contratoId: number
  cdContratoPrincipal: string
  txJustificativa: string
  dt_Anexado: Date
  qtd_Analise: number
  retorno_Analise: Date
  status: string
  nuAnoMesCompetencia: number
}
const AttachDocumentsServices = () => {
  const path = 'AnexarPendencia'

  const create = async (
    requestObj: RequestAnexarPendencia
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete/${id}`)

  const get = async (
    idUsuario: number
  ): Promise<AxiosResponse<PendenciaCollapse[]>> =>
    await RequestREAD.get(`${path}/ListarPendencias`, { params: { idUsuario } })

  const patch = async (body: UpdateDocument[]): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, body)

  return { create, del, get, patch }
}

const SearchDocumentsServices = () => {
  const path = 'DocumentoPesquisar'

  const get = async (
    params: FiltroPrincipal
  ): Promise<AxiosResponse<IPaginatedResponse<SearchDocuments>>> =>
    await RequestREAD.get(`${path}/FiltroPrincipal`, {
      params: params
    })

  const getSecundario = async (): Promise<AxiosResponse<SearchDocuments[]>> =>
    await RequestREAD.get(path + '/FiltroSecundario')

  return { get, getSecundario }
}

interface FiltroPrincipal {
  UsuarioId: number
  CdContrato?: string
  TipoDoc?: string
  Status?: string
  CompetenciaInicio?: string
  CompetenciaFim?: string
  DataAnexadaInicio?: string
  DataAnexadaFim?: string
  enumFilter?: number
  TipoPendenciaId?: number
  pageNumber: number
  pageSize: number
}

export interface GetDocumentResponse {
  idMovDocumento: number
  movimentacaoId: number
  tipoPendenciaId: number
  dtCriacao: Date
  flAnexado: string
  dtAnexado: Date
  cdStatus?: any
  txDescricao?: any
  cdCalcRisco: string
  vlCalcRisco: number
  txFilePath?: any
  txFilename?: any
  movimentacao?: any
  tipoPendencia?: any
  flPendente?: any
}

const MonthlyDocumentsServices = () => {
  const path = 'AnexarDocumentacaoMensal'
  const path2 = 'DocMovDocumento'
  const path3 = 'AnexarPendencia'

  const create = async (requestObj: RequestDocMensal): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path2}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path2}/Delete/${id}`)

  const put = async (body: UpdateDocument[]): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path2}/Upload`, body)

  const get = async (
    IdUsuario: number,
    idUsuarioCSN?: number
  ): Promise<AxiosResponse<CollpaseContrato[]>> =>
    await RequestREAD.get(path, {
      params: {
        IdUsuario,
        idUsuarioCSN
      }
    })

  const GetExcelPendencia = async (params: {
    IdUsuario: number
  }): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path3}/GetExcelPendencia`, { params })

  return { GetExcelPendencia, create, del, get, put }
}

export interface UpdateDocument {
  idMovDoc: number
  fornecedor: string
  tipoPendenciaId: number
  dtAnexado: string
  nomeArquivo: string
  descricao: string
  dtEfetivacao: string
  file: string
  contratoId: number
  competencia: string
  cdDocto: string
}

const TypesDocumentsGSTService = () => {
  const path = 'TipoDocumentoGst'

  // const create = async (requestObj: RequestDocMensal): Promise<AxiosResponse> =>
  //   await RequestCDU.post(`${path2}/Create`, requestObj)

  //   const del = async (id: number): Promise<AxiosResponse> =>
  //     await RequestCDU.delete(`${path}/Delete?id=${id}`)
  const get = async (): Promise<AxiosResponse<TypesDocumentGst[]>> =>
    await RequestREAD.get(path)

  //   const patch = async (): Promise<AxiosResponse> =>
  //     await RequestCDU.patch(`${path}/Update`)

  return { get }
}

export interface SearchDocuments {
  cdContrato: string
  txTipo: string
  dtAnexado: Date
  competencia: number
  diasPendentes: number
  retornoAnalise: Date
  gedExternalId: number
  qtdAnalises: number
  cdStatusAnalise?: any
  nmFornecedor: string
}

export interface RequestDocMensal {
  movimentacaoId: number
  contrato: number
  nuContrato: number
  cdDocto: string
  fornecedor: string
  competencia: string
  tipoPendenciaId: number
  dtAnexado: Date
  nomeArquivo: string
  descricao: string
  dtEfetivacao: Date
  file: string
  contratoId: number
}

export interface RequestAnexarPendencia {
  cdContrato?: string
  cdDocto?: string
  nmFornecedor?: string
  nuAnoMesCompetencia?: Date
  movimentacaoId?: number
  tipoPendenciaId?: number
  dtAnexado?: Date
  nmArquivo?: string
  txDescricao?: string
  dtEfetivacao?: Date
  file?: string
}

export interface TypesDocumentGst {
  idTipoDocumentoGst: number
  txTipo: string
  txDescricao: string
  documentoGst?: any[]
}

export interface DocMonthly {
  idContrato: number
  cdContrato: string
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  txObjetoContrato: string
  nmFornecedor: string
  contratoId: number
  nuAnoMesCompetencia?: any
}

export interface Anexo {
  cdGedExternalId: number
  idMovDocumento: number
  txTipo: string
  dtAnexado: Date
  txDescricaoTipo: string
  txObservacaoAnexo: string
  txDescricaoAnexo: string
  txJustificativa: string
  dtRetorno: Date
  gedExternalId: number
  cdStatus: string
  base64?: string
  filename?: string
  tipoPendenciaId: number
}

export interface CollpaseContrato {
  idContrato: number
  competencia: string
  cdContrato: string
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  txObjetoContrato: string
  anoMesCompetencia: string
  nmFornecedor: string
  cdDocumento: string
  idMovimentacao: number
  contratoId: number
  anexos: Anexo[]
}

export interface AnexoPendencia {
  idMovDocumento: number
  movimentacaoId: number
  cdGedExternalId: number
  txObservacaoAnexo: string
  txTipo: string
  dtAnexado: Date
  txDescricaoTipo: string
  txDescricaoAnexo: string
  txJustificativa?: any
  dtRetorno: Date
  cdStatus: string
  competencia: number
  diasPendentes: number
  idContrato: number
  qtdAnalises: number
  base64?: string
  filename?: string
  tipoPendenciaId: number
}

export interface PendenciaCollapse {
  idContrato: number
  cdContrato: string
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  txObjetoContrato: string
  competencia: Date
  tipoPendenciaId: number
  nmFornecedor: string
  cdDocumento: string
  contratoId: number
  anexos: AnexoPendencia[]
}

export {
  SearchDocumentsServices,
  AttachDocumentsServices,
  MonthlyDocumentsServices,
  TypesDocumentsGSTService
}
